<template>
  <div class="test">
    <div :style="dstyle">
      <span v-for="(item,i) in list" :key="i">{{ item+'、' }}</span>
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      list:[this.$t('haoHao'),this.$t('haoLei'),this.$t('tianQiong')],
      dstyle:"color:#d841ac"
    }
  },
  mounted(){
    this.open()
  },
  methods:{
    open(){
      let a =this.$t('huHu')
      this.$message.error(this.$t('jinTianTingQu'))
      this.$message.error(this.$t('laLaLa')+a)
    }
  }
}
</script>
<style scoped>
.test{
  background: rgba(#fdf, green, blue, alpha);
}
</style>
